<div class="fx-bonus-setting text-white">

  <div class="card-body">
    <form class="form form-horizontal" #formSetting="ngForm">
      <div class="row mb-20">
        <div class="col-lg-2 col-12  fs-18 font-bold"> Campaign Name</div>
        <div class="col-lg-10 col-12">
          <div class="row">
            <div class="col-lg-6 col-12">
              <input class="w-100 with-placeholder inp-filled" type="text" disabled
                     placeholder="Affiliate link Name" name="affiliateName" [(ngModel)]="bonus.name"
                     required>
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-20 mt-5">
        <div class="col-lg-2 col-12  fs-18 font-bold mb-3"> Campaign Date</div>
        <div class="col-lg-10 col-12 mb-3">
          <div class="d-flex">
            <div class="section-holder">
              <span class="text sub-label">Start Time</span>
              <ng-template #startInvalid>
                <p-calendar
                  [(ngModel)]="bonus.start_time" name="start_time" [disabled]="isEdit"
                  [placeholder]="'dd/mm/yyyy HH:mm'" [dateFormat]="'dd/mm/yy'" [showIcon]="true"
                  [showTime]="true" inputStyleClass="form-control bg-dark" required></p-calendar>
              </ng-template>
              <p-calendar
                *ngIf="isStartValid; else startInvalid"
                [(ngModel)]="bonus.start_time" name="start_time" disabled
                [placeholder]="'dd/mm/yyyy HH:mm'" [dateFormat]="'dd/mm/yy'"
                [showTime]="true" inputStyleClass="form-control bg-dark" ></p-calendar>
            </div>
            <div class="section-holder ms-5">
              <span class="text sub-label">End Time</span>
              <p-calendar [(ngModel)]="bonus.end_time" name="end_time" [disabled]="isEdit"
                          [placeholder]="'dd/mm/yyyy HH:mm'" [dateFormat]="'dd/mm/yy'" [showIcon]="true"
                          [showTime]="true" inputStyleClass="form-control bg-dark" required></p-calendar>
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-20">
        <div class="col-lg-2 m-auto col-12 fs-18 font-bold" style="padding-bottom: 21.5px;">Target Person</div>
        <div class="col-lg-10 col-12">
          <div class="row">
            <div class="col-lg-6 col-12">
              <p-autoComplete class="" [dropdown]="true" name="user" [disabled]="isEdit"
                              [suggestions]="filterList" [(ngModel)]="bonus.user" (ngModelChange)="onSelectData()"
                              (completeMethod)="filterEmail($event)" field="email"></p-autoComplete>
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-20">
        <div class="col-lg-2 col-12 fs-18 font-bold" style="padding-bottom: 21.5px;">Bonus On Open Account</div>
        <div class="col-lg-10 col-12">
          <div class="row">
            <div class="col-lg col-12">
              <span class="me-1">OFF</span>
              <mat-slide-toggle
                class="red text-green"
                [disabled]="isEdit"
                name="is_enable_account"
                [checked]="bonus.is_enable_account"
                [(ngModel)]="bonus.is_enable_account"
                (ngModelChange)="rePatchForAccount($event)"
              >ON
              </mat-slide-toggle>
              <div class="mt-4 d-flex" *ngIf="bonus.is_enable_account">
                <div class="section-holder mb-4 col-5">
                  <span class="text sub-label">Bonus JPY</span>
                  <input type="number" name="bonusJPY"

                         class="extent with-placeholder sub-bonus-inp text-center" placeholder="ex:1000"
                         [(ngModel)]="bonus.data?.open_account.jpy_bonus" numberOnly autocomplete="off"
                         required [disabled]="isEdit"/>
                  <span class="ms-1"></span>
                </div>
                <div class="section-holder mb-4 col-5">
                  <span class="text sub-label">Bonus USD</span>
                  <input type="number" name="bonusUSD" class="extent with-placeholder sub-bonus-inp"

                         placeholder="ex:100" autocomplete="off"
                         [(ngModel)]="bonus.data?.open_account.usd_bonus" required [disabled]="isEdit"/>
                  <span class="ms-1"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-20">
        <!-- <div class="col-lg-2 col-12  fs-18 font-bold">Method</div> -->

        <div class="col-lg-2 m-auto col-12 fs-18 font-bold" style="padding-bottom: 21.5px;">Bonus On Deposit</div>
        <div class="col-lg-10 col-12">
          <div class="row">
            <div class="col-lg-10 col-12">
              <span class="me-1">OFF</span>
              <mat-slide-toggle
                [disabled]="isEdit"
                class="red text-green"
                [checked]="bonus.is_enable_deposit"
                (ngModelChange)="rePatchChild($event)"
                [(ngModel)]="bonus.is_enable_deposit" name="is_enable_deposit">ON
              </mat-slide-toggle>
            </div>
          </div>
        </div>
      </div>

      <div class="row mb-20 conditions" *ngIf="bonus.is_enable_deposit">
        <ng-container *ngFor="let con of bonus.data.deposit.conditions; let i = index">
          <div class="col-lg-2 m-auto col-12 fs-18 font-bold" style="padding-bottom: 21.5px;">Condition {{i +
          1}}</div>
          <div class="col-lg-10 col-12">
            <div class="mt-4 d-flex">
              <div class="col">
                <input class="extent with-placeholder text-center" type="text" numberOnly
                       name="_threshold{{i}}" placeholder="ex: 100"
                       (keyup)="onUpdateRateUJ('conditions', i)" [(ngModel)]="con.threshold"
                       [disabled]="isEdit"/>
                <span class="m-1 sub-label">JPY</span>
                <input type="number" class="extent ms-3 with-placeholder" name="view_threshold{{i}}"
                       placeholder="ex: 100" [disabled]="true"
                       [value]="viewBonus.conditions[i].threshold"/>
                <span class="m-1 sub-label">USD</span>
                <input class="ms-3  with-placeholder" type="number" [(ngModel)]="con.rate"
                       placeholder="ex: 10" name="_rate{{i}}" [disabled]="isEdit"/>
                <span class="ms-1 sub-label">%</span>
              </div>
            </div>
          </div>
        </ng-container>
      </div>

      <div class="row mb-20 {{!bonus.is_enable_account ? ' mt-3' : ''}}" *ngIf="bonus.is_enable_deposit">
        <div class="col-lg-2 col-12  fs-18 font-bold">Upper Limit</div>
        <div class="col-lg-10 col-12">
          <div class="d-flex">
            <div class="col-5">
              <input class="extent with-placeholder sub-bonus-inp text-center" type="text"
                     name="bonusLimit" placeholder="ex:10" autocomplete="off"
                     (keyup)="onUpdateRateUJ('up_limit_usd', 0)" [(ngModel)]="bonus.data.deposit.up_limit"
                     required numberOnly [disabled]="isEdit"/>
              <span class="ms-1 sub-label">JPY</span>

            </div>
            <div class="col-5">
              <input type="number" name="bonusLimitUSD"
                     class="extent sub-bonus-inp with-placeholder text-center" autocomplete="off"
                     placeholder="ex:10" [disabled]="true" [value]="viewBonus.up_limit_usd" required/>
              <span class="ms-1 sub-label">USD</span>
            </div>

          </div>
        </div>
      </div>
      <ng-container *ngIf="bonus.is_enable_deposit">
        <div class="row mb-20">
          <div class="col-lg-2 col-12  fs-18 font-bold">Multiple</div>
          <div class="col-lg-10 col-12">
            <span class="me-1">OFF</span>
            <mat-slide-toggle [disabled]="isEdit" class="red text-green" [(ngModel)]="bonus.data.deposit.multiple_time" name="multiple_time"
                              [checked]="bonus.data.deposit.multiple_time"
                              (change)="bonus.data.deposit.multiple_time = $event.checked">ON
            </mat-slide-toggle>
          </div>
        </div>
        <div class="row mb-20">
          <div class="col-lg-2 col-12  fs-18 font-bold">Bonus Timeout</div>
          <div class="col-lg-10 col-12">
            <select class="selector" name="dfw" [(ngModel)]="bonus.data.deposit.dfw" [disabled]="isEdit">
              <option *ngFor="let t of timeoutSelector()">{{t}}</option>
            </select>
          </div>
        </div>
        <div class="row mb-20">
          <div class="col-lg-2 col-12  fs-18 font-bold">Bonus Type</div>
          <div class="col-lg-10 col-12">
            <select class="selector" name="nonusType" [disabled]="isEdit"
                    [(ngModel)]="bonus.data.bonus_type">
              <option [ngValue]="0">Normal</option>
              <option [ngValue]="1">Before</option>
              <option [ngValue]="2">After</option>
            </select>
          </div>
        </div>
      </ng-container>
      <hr edit-permission/>
      <div class="row">
        <div class="dialog__footer d-flex justify-content-end">
          <button type="button" class="btn btn-transparent rounded mr-2" (click)="back()">
            Back
          </button>
          <button *ngIf="isEdit === true" [hidden]="isExpired" class="btn btn-red rounded ml-2" type="button"
                  (click)="isEdit = false">
            Edit
          </button>
          <button *ngIf="isEdit === false" class="btn btn-red rounded ml-2" type="button"
                  (click)="submitSetting()">
            Save
          </button>
        </div>

      </div>
    </form>
  </div>
</div>
<div class="fx-bonus-setting text-white">
  <div class="card-header pt-0" style="border-bottom: 0; height: 40px">
    <div class="pb-2" style="border-top: 1px solid rgb(240 240 240 / 25%) !important"></div>
    <div class="d-flex align-items-center position-relative h-100">
      <button *ngIf="logMode === 'detail'" mat-icon-button (click)="onBackToLogs()">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <span
        class="header-brand d-flex align-items-center"
        [class.navigated]="logMode === 'detail'"
      >Logs</span>
    </div>
  </div>
  <div class="card-body">
    <div class="row" *ngIf="logMode === 'overview'; else detailOfOne">
      <div class="col-md-12 col-xs-12">
        <div class="table-responsive">
          <table class="rox-table table-bordered bg-dark">
            <thead>
              <tr>
                <th class="text-center">Time</th>
                <th class="text-center">Field</th>
                <th class="text-center">Old value</th>
                <th class="text-center">New value</th>
                <th class="text-center">Notification Email Status</th>
              </tr>
            </thead>
            <tbody>
              <ng-template #nodata>
                <tr><td colspan="5" class="text-center text-muted">No logs data found</td></tr>
              </ng-template>
              <ng-container *ngIf="logs.length > 0; else nodata">
                <tr *ngFor="let row of logs; index as i; last as l">
                  <td>{{row.create_time | date: 'dd/MM/yyyy HH:mm' : 'GMT+09'}}</td>
                  <td>
                    <div class="item-cell" *ngIf="row.old_data?.name !== row.new_data?.name">Campaign Name</div>
                    <div class="item-cell" *ngIf="row.old_data?.start_time !== row.new_data?.start_time">Start time</div>
                    <div class="item-cell" *ngIf="row.old_data?.end_time !== row.new_data?.end_time">End time</div>
                    <div class="item-cell" *ngIf="row.old_data?.email !== row.new_data?.email">Target person</div>
                    <div class="item-cell" *ngIf="row.old_data?.is_enable_account !== row.new_data?.is_enable_account">Bonus on open account</div>
                    <div class="item-cell" *ngIf="row.old_data?.data?.open_account?.jpy_bonus !== row.new_data?.data?.open_account?.jpy_bonus">Bonus amount (Yen)</div>
                    <div class="item-cell" *ngIf="row.old_data?.data.open_account?.usd_bonus !== row.new_data?.data.open_account?.usd_bonus">Bonus amount (USD)</div>
                    <div class="item-cell" *ngIf="row.old_data?.is_enable_deposit !== row.new_data?.is_enable_deposit">Bonus On Deposit</div>
                    <ng-container *ngIf="row.new_data?.is_enable_deposit === true">
                      <div class="item-cell" *ngIf="row.old_data?.data.deposit.conditions[0]?.threshold !== row.new_data?.data.deposit.conditions[0]?.threshold">Condition 1</div>
                      <div class="item-cell" *ngIf="row.old_data?.data.deposit.conditions[0]?.rate !== row.new_data?.data.deposit.conditions[0]?.rate">Condition 1 bonus percent</div>
                      <div class="item-cell" *ngIf="row.old_data?.data.deposit.conditions[1]?.threshold !== row.new_data?.data.deposit.conditions[1]?.threshold">Condition 2</div>
                      <div class="item-cell" *ngIf="row.old_data?.data.deposit.conditions[1]?.rate !== row.new_data?.data.deposit.conditions[1]?.rate">Condition 2 bonus percent</div>
                      <div class="item-cell" *ngIf="row.old_data?.data.deposit.conditions[2]?.threshold !== row.new_data?.data.deposit.conditions[2]?.threshold">Condition 3</div>
                      <div class="item-cell" *ngIf="row.old_data?.data.deposit.conditions[2]?.rate !== row.new_data?.data.deposit.conditions[2]?.rate">Condition 3 bonus percent</div>
                      <div class="item-cell" *ngIf="row.old_data?.data.deposit.conditions[3]?.threshold !== row.new_data?.data.deposit.conditions[3]?.threshold">Condition 4</div>
                      <div class="item-cell" *ngIf="row.old_data?.data.deposit.conditions[3]?.rate !== row.new_data?.data.deposit.conditions[3]?.rate">Condition 4 bonus percent</div>
                      <div class="item-cell" *ngIf="row.old_data?.data.deposit?.up_limit != row.new_data?.data.deposit?.up_limit && row.new_data?.is_enable_deposit">Upper limit</div>
                      <div class="item-cell" *ngIf="row.old_data?.data.deposit?.multiple_time !== row.new_data?.data.deposit?.multiple_time">Multiple time</div>
                      <div class="item-cell" *ngIf="row.old_data?.data.deposit.dfw !== row.new_data?.data.deposit.dfw">Bonus timeout</div>
                      <div class="item-cell" *ngIf="row.old_data?.data.bonus_type !== row.new_data?.data.bonus_type">Bonus type</div>
                    </ng-container>
                  </td>
                  <td>
                    <ng-container *ngIf="row.old_data">
                      <div class="item-cell" *ngIf="row.old_data?.name !== row.new_data?.name">{{row.old_data?.name}}</div>
                      <div class="item-cell" *ngIf="row.old_data?.start_time !== row.new_data?.start_time">{{row.old_data?.start_time | date: 'dd/MM/yyyy HH:mm'}}</div>
                      <div class="item-cell" *ngIf="row.old_data?.end_time !== row.new_data?.end_time">{{row.old_data?.end_time | date: 'dd/MM/yyyy HH:mm'}}</div>
                      <div class="item-cell" *ngIf="row.old_data?.email !== row.new_data?.email">{{row.old_data?.email}}</div>
                      <div class="item-cell" *ngIf="row.old_data?.is_enable_account !== row.new_data?.is_enable_account">{{row.old_data?.is_enable_account === true ? 'On' : 'Off'}}</div>
                      <div class="item-cell" *ngIf="row.old_data?.data.open_account?.jpy_bonus !== row.new_data?.data.open_account?.jpy_bonus">{{row.old_data?.data.open_account?.jpy_bonus}}</div>
                      <div class="item-cell" *ngIf="row.old_data?.data.open_account?.usd_bonus !== row.new_data?.data.open_account?.usd_bonus">{{row.old_data?.data.open_account?.usd_bonus}}</div>
                      <div class="item-cell" *ngIf="row.old_data?.is_enable_deposit !== row.new_data?.is_enable_deposit">{{row.old_data?.is_enable_deposit === true ? 'On' : 'Off'}}</div>
                      <ng-container *ngIf="row.new_data?.is_enable_deposit === true">
                        <div class="item-cell" *ngIf="row.old_data?.data.deposit.conditions[0]?.threshold !== row.new_data?.data.deposit.conditions[0]?.threshold">{{row.old_data?.data.deposit.conditions[0]?.threshold}}</div>
                        <div class="item-cell" *ngIf="row.old_data?.data.deposit.conditions[0]?.rate !== row.new_data?.data.deposit.conditions[0]?.rate">{{(row.old_data?.data.deposit.conditions[0]?.rate) ? (row.old_data?.data.deposit.conditions[0]?.rate * 100) : ''}}</div>
                        <div class="item-cell" *ngIf="row.old_data?.data.deposit.conditions[1]?.threshold !== row.new_data?.data.deposit.conditions[1]?.threshold">{{row.old_data?.data.deposit.conditions[1]?.threshold}}</div>
                        <div class="item-cell" *ngIf="row.old_data?.data.deposit.conditions[1]?.rate !== row.new_data?.data.deposit.conditions[1]?.rate">{{(row.old_data?.data.deposit.conditions[1]?.rate) ? (row.old_data?.data.deposit.conditions[1]?.rate * 100) : ''}}</div>
                        <div class="item-cell" *ngIf="row.old_data?.data.deposit.conditions[2]?.threshold !== row.new_data?.data.deposit.conditions[2]?.threshold">{{row.old_data?.data.deposit.conditions[2]?.threshold}}</div>
                        <div class="item-cell" *ngIf="row.old_data?.data.deposit.conditions[2]?.rate !== row.new_data?.data.deposit.conditions[2]?.rate">{{(row.old_data?.data.deposit.conditions[2]?.rate) ? (row.old_data?.data.deposit.conditions[2]?.rate * 100) : ''}}</div>
                        <div class="item-cell" *ngIf="row.old_data?.data.deposit.conditions[3]?.threshold !== row.new_data?.data.deposit.conditions[3]?.threshold">{{row.old_data?.data.deposit.conditions[3]?.threshold}}</div>
                        <div class="item-cell" *ngIf="row.old_data?.data.deposit.conditions[3]?.rate !== row.new_data?.data.deposit.conditions[3]?.rate">{{(row.old_data?.data.deposit.conditions[3]?.rate) ? (row.old_data?.data.deposit.conditions[3]?.rate * 100) : ''}}</div>
                        <div class="item-cell" *ngIf="row.old_data?.data.deposit?.up_limit != row.new_data?.data.deposit?.up_limit">{{row.old_data?.data.deposit?.up_limit}}</div>
                        <div class="item-cell" *ngIf="row.old_data?.data.deposit?.multiple_time !== row.new_data?.data.deposit?.multiple_time">{{row.old_data?.data.deposit?.multiple_time === 1 ? 'Multiple' : 'Single'}}</div>
                        <div class="item-cell" *ngIf="row.old_data?.data.deposit.dfw !== row.new_data?.data.deposit.dfw">{{row.old_data?.data.deposit.dfw}}</div>
                        <div class="item-cell" *ngIf="row.old_data?.data.bonus_type !== row.new_data?.data.bonus_type">{{bonusType[row.old_data?.data.bonus_type ?? 4]}}</div>
                      </ng-container>
                    </ng-container>
                  </td>
                  <td>
                    <ng-container *ngIf="row.new_data">
                      <div class="item-cell" *ngIf="row.old_data?.name !== row.new_data?.name">{{row.new_data?.name}}</div>
                      <div class="item-cell" *ngIf="row.old_data?.start_time !== row.new_data?.start_time">{{row.new_data?.start_time | date: 'dd/MM/yyyy HH:mm'}}</div>
                      <div class="item-cell" *ngIf="row.old_data?.end_time !== row.new_data?.end_time">{{row.new_data?.end_time | date: 'dd/MM/yyyy HH:mm'}}</div>
                      <div class="item-cell" *ngIf="row.old_data?.email !== row.new_data?.email">{{row.new_data?.email}}</div>
                      <div class="item-cell" *ngIf="row.old_data?.is_enable_account !== row.new_data?.is_enable_account">{{row.new_data?.is_enable_account === true ? 'On' : 'Off'}}</div>
                      <div class="item-cell" *ngIf="row.old_data?.data.open_account?.jpy_bonus !== row.new_data?.data.open_account?.jpy_bonus">{{row.new_data?.data.open_account?.jpy_bonus}}</div>
                      <div class="item-cell" *ngIf="row.old_data?.data.open_account?.usd_bonus !== row.new_data?.data.open_account?.usd_bonus">{{row.new_data?.data.open_account?.usd_bonus}}</div>
                      <div class="item-cell" *ngIf="row.old_data?.is_enable_deposit !== row.new_data?.is_enable_deposit">{{row.new_data?.is_enable_deposit === true ? 'On' : 'Off'}}</div>
                      <ng-container *ngIf="row.new_data?.is_enable_deposit === true">
                        <div class="item-cell" *ngIf="row.old_data?.data.deposit.conditions[0]?.threshold !== row.new_data?.data.deposit.conditions[0]?.threshold">{{row.new_data?.data.deposit.conditions[0]?.threshold}}</div>
                        <div class="item-cell" *ngIf="row.old_data?.data.deposit.conditions[0]?.rate !== row.new_data?.data.deposit.conditions[0]?.rate">{{(row.new_data?.data.deposit.conditions[0]?.rate) ? row.new_data?.data.deposit.conditions[0]?.rate * 100 : ''}}</div>
                        <div class="item-cell" *ngIf="row.old_data?.data.deposit.conditions[1]?.threshold !== row.new_data?.data.deposit.conditions[1]?.threshold">{{row.new_data?.data.deposit.conditions[1]?.threshold}}</div>
                        <div class="item-cell" *ngIf="row.old_data?.data.deposit.conditions[1]?.rate !== row.new_data?.data.deposit.conditions[1]?.rate">{{(row.new_data?.data.deposit.conditions[1]?.rate) ? row.new_data?.data.deposit.conditions[1]?.rate * 100 : ''}}</div>
                        <div class="item-cell" *ngIf="row.old_data?.data.deposit.conditions[2]?.threshold !== row.new_data?.data.deposit.conditions[2]?.threshold">{{row.new_data?.data.deposit.conditions[2]?.threshold}}</div>
                        <div class="item-cell" *ngIf="row.old_data?.data.deposit.conditions[2]?.rate !== row.new_data?.data.deposit.conditions[2]?.rate">{{(row.new_data?.data.deposit.conditions[2]?.rate) ? row.new_data?.data.deposit.conditions[2]?.rate * 100 : ''}}</div>
                        <div class="item-cell" *ngIf="row.old_data?.data.deposit.conditions[3]?.threshold !== row.new_data?.data.deposit.conditions[3]?.threshold">{{row.new_data?.data.deposit.conditions[3]?.threshold}}</div>
                        <div class="item-cell" *ngIf="row.old_data?.data.deposit.conditions[3]?.rate!== row.new_data?.data.deposit.conditions[3]?.rate">{{(row.new_data?.data.deposit.conditions[3]?.rate) ? row.new_data?.data.deposit.conditions[3]?.rate * 100 : ''}}</div>
                        <div class="item-cell" *ngIf="row.old_data?.data.deposit?.up_limit != row.new_data?.data.deposit?.up_limit && row.new_data?.is_enable_deposit">{{row.new_data?.data.deposit?.up_limit}}</div>
                        <div class="item-cell" *ngIf="row.old_data?.data.deposit?.multiple_time !== row.new_data?.data.deposit?.multiple_time">{{row.new_data?.data.deposit?.multiple_time === 1 ? 'Multiple' : 'Single'}}</div>
                        <div class="item-cell" *ngIf="row.old_data?.data.deposit.dfw !== row.new_data?.data.deposit.dfw">{{row.new_data?.data.deposit.dfw}}</div>
                        <div class="item-cell" *ngIf="row.old_data?.data.bonus_type !== row.new_data?.data.bonus_type">{{bonusType[row.new_data?.data.bonus_type ?? 4]}}</div>
                      </ng-container>
                    </ng-container>
                  </td>
                  <td>
                    <ng-template #noSendMail>
                      <pre>{{row | json}}</pre>
                    </ng-template>
                    <ng-container *ngIf="row.email_sended?.sended_mail?.length > 0;">
                      <div
                        class="text-center as-clickable"
                        role="button"
                        matRipple
                        (click)="openDetails(row)"
                      >Total Receivers: {{row?.totalReceivers}}</div>
                      <div [style.color]="statusOfEmail[3].color" class="text-center">Done: {{row?.done[0]?.total_email || 0}}</div>
                      <div [style.color]="statusOfEmail[4].color" class="text-center">Failed: {{row?.failed[0]?.total_email || 0}}</div>
                      <div [style.color]="statusOfEmail[2].color" class="text-center">Sending: {{(row?.sending[0]?.total_email || 0) + (row?.new[0]?.total_email || 0)}}</div>
                    </ng-container>
                  </td>
                </tr>
              </ng-container>
              <!--<tr *ngFor="let item of groupByIdData; index as i" class="inner-cell">
                <td>
                  <div>{{item[0]?.createTime | date: 'dd/MM/yyyy HH:mm' : 'GMT+09'}}</div>
                </td>
                <td>
                  <div *ngFor="let inner of item" class="item-cell">{{inner.field}}</div>
                </td>
                <td>
                  <div *ngFor="let inner of item" class="item-cell">{{inner.oldValue}}</div>
                </td>
                <td>
                  <div *ngFor="let inner of item" class="item-cell">{{inner.newValue}}</div>
                </td>
                <td>
                  <div
                    class="text-center as-clickable"
                    role="button"
                    matRipple
                    (click)="openDetails(rawLogs[i])"
                  >Total Receivers: {{rawLogs[i]?.totalReceivers}}</div>
                  <div [style.color]="statusOfEmail[3].color" class="text-center">Done: {{rawLogs[i]?.done[0]?.total_email || 0}}</div>
                  <div [style.color]="statusOfEmail[4].color" class="text-center">Failed: {{rawLogs[i]?.failed[0]?.total_email || 0}}</div>
                  <div [style.color]="statusOfEmail[2].color" class="text-center">Sending: {{(rawLogs[i]?.sending[0]?.total_email || 0) + (rawLogs[i]?.new[0]?.total_email || 0)}}</div>
                </td>
              </tr>-->
              <!--<tr *ngFor="let item of logHistory;let i = index" >
                <td class="text-start" *ngIf="">
                  {{item.createTime | date:"dd/MM/yyyy hh:mm"}}
                </td>
                <td>{{ item.field}}</td>
                <td>{{ item.oldValue}}</td>
                <td>{{ item.newValue}}</td>
                <td > &lt;!&ndash;[rowSpan]="logHistory.length"&ndash;&gt;
                  <div>
                    <div
                      class="text-center as-clickable"
                      role="button"
                      matRipple
                      (click)="openDetails(item.id)"
                    >Total Receicers: 2</div>
                  </div>
                </td>
              </tr>-->
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #detailOfOne>

  <div class="d-flex justify-content-between">
    <div class="search-box input-group search-group">
      <input type="text" class="form-control bg-dark search-input" [(ngModel)]="searchDetailText" placeholder="Search Email" (keyup.enter)="searchDetails()">
      <button mat-button class="btn btn-main" (click)="searchDetails()">Search</button>
    </div>
    <button *ngIf="currentItemDetail?.failed?.length > 0 && !isExpired" matRipple class="btn btn-transparent rounded" (click)="resendAll()" [disabled]="isResendProcessing">Resend All</button>
  </div>
  <div class="d-flex justify-content-end mt-3">
    <div class="text-muted fst-italic">*Resend All function won't resend email(s) to whom having Status = Pending</div>
  </div>
  <div>Total Receivers: {{detailOfLogOverview.totalRecords}}</div>
  <div class="d-flex align-items-center mt-2">
    <div class="me-4" [style.color]="statusOfEmail[3].color">Done: {{detailOfLogOverview.done}}</div>
    <div class="me-4" [style.color]="statusOfEmail[4].color">Failed: {{detailOfLogOverview.failed}}</div>
    <div class="me-4" [style.color]="statusOfEmail[2].color">Sending: {{detailOfLogOverview.sending}}</div>
    <button mat-icon-button class="sync-btn" (click)="refresh()">
      <mat-icon>autorenew</mat-icon>
    </button>
  </div>
  <div class="table-responsive mt-3">
    <table class="rox-table table-bordered bg-dark">
      <thead>
        <tr>
          <th class="text-center">ID</th>
          <th class="text-center">Username</th>
          <th class="text-center">Email</th>
          <th class="text-center">Status</th>
        </tr>
      </thead>
      <ng-template #noData>
        <tbody>
          <tr>
            <td colspan="4" class="text-muted text-center">No data found</td>
          </tr>
        </tbody>
      </ng-template>
      <tbody *ngIf="sentMailList.length > 0; else noData">
        <tr *ngFor="let item of sentMailList | paginate: {
              itemsPerPage: sentMailListPageInfo.page_size,
              currentPage: sentMailListPageInfo.page,
              totalItems: sentMailListPageInfo.total,
              id: 'email_promox'
        }">
          <td class="text-center">{{item.user_id}}</td>
          <td class="text-center">{{item.username}}</td>
          <td class="text-center">{{item.email}}</td>
          <td style="min-width: 130px" class="position-relative text-center p-3">
            <span [style.color]="statusOfEmail[item.status].color">{{statusOfEmail[item.status].label}}</span>
            <button *ngIf="item.status === 4 && !isExpired" (click)="resendOne(item.id)" matRipple class="btn btn-transparent rounded action-button" [disabled]="isResendProcessing">Resend</button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="d-flex justify-content-between mt-3">
    <div class="paginator">
      <pagination-controls
        *ngIf="sentMailListPageInfo.total > 10"
        id="email_promox"
        (pageChange)="pageChanged($event)"
        autoHide="true"
        responsive="true"
        previousLabel="Prev"
        nextLabel="Next"
      >
      </pagination-controls>
    </div>
    <div class="">Total Records: {{sentMailListPageInfo.total}}</div>
  </div>
</ng-template>
